interface SectionNamesConst {
    TOP_SECTION: 'topSection',
    CARDS_SECTION: 'cardsSection',
    CONTENT_SECTION_1: 'contentSection1',
    CONTENT_SECTION_2: 'contentSection2',
    CONTENT_SECTION_3: 'contentSection3',
    FEED_SECTION: 'feedSection',
}

export const SECTION_NAMES:SectionNamesConst = {
  TOP_SECTION: 'topSection',
  CARDS_SECTION: 'cardsSection',
  CONTENT_SECTION_1: 'contentSection1',
  CONTENT_SECTION_2: 'contentSection2',
  CONTENT_SECTION_3: 'contentSection3',
  FEED_SECTION: 'feedSection',
};

export const SLOT_NAMES = {
  TOP_AD: 'topAd',
  ONE_ON_ONE: 'oneOnOne',
  IN_ARTICLE: 'inArticle',
  SIDE_BAR_1: 'sideBar1',
  SIDE_BAR_2: 'sideBar2',
};
